<div class="page-actions">
  <dv-button
    color="primary"
    icon="add"
    (click)="onCreateClick()"
    [disabled]="(canAddUser$ | async) === false"
    routerLink="new/information">
    {{ 'User.New' | translate | uppercase }}
  </dv-button>
</div>

<dv-vertical-splitter
  [resizableSide]="resizableSide.Right"
  id="users-vertical-splitter">
  <div left-side>
    <app-users-grid></app-users-grid>
  </div>
  <div right-side>
    <router-outlet />
  </div>
</dv-vertical-splitter>
